import { render, staticRenderFns } from "./InfoRyby.vue?vue&type=template&id=14df0772&"
import script from "./InfoRyby.vue?vue&type=script&lang=js&"
export * from "./InfoRyby.vue?vue&type=script&lang=js&"
import style0 from "./InfoRyby.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports